module.exports = "fonts/LYjNdG7kmE0gfaJ9pRtB.woff2";